import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import configureStore, { history } from "./store";
import App from "./App.js";
import * as Sentry from "@sentry/react";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import "./shared/styles/css/default.scss";
import "./shared/styles/css/shared.scss";
import "./shared/styles/fonts/gt-zirkon/stylesheet.css";
import "./shared/styles/fonts/icons/style.css";
import TagManager from 'react-gtm-module'

const store = configureStore(/* initial state if any */);

Sentry.init({
  dsn: "https://60c0508396d871a63b5132c3bb0cf386@o1138927.ingest.sentry.io/4506660658806784",
  environment: process.env.REACT_APP_ENV_NAME,
  tracesSampleRate: 1.0,
});

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_ENV_NAME === 'production' ? 'GTM-5QJ3WHC' : 'GTM-WJ8JTLN9'
}

TagManager.initialize(tagManagerArgs)

ReactDOM.render(
  <Provider store={store}>
    <App history={history} />
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
